<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist ref="SetBtn" @help="help"></buttonlist>
		<el-card class="box-card">
			<div style="width:1040px;min-width:1040px">
				<table>
					<tr>
						<td style="width:60px;min-width:60px"><span>{{$t('getapi[112]')}}</span></td>
						<td style="width:140px;min-width:140px">
							<routejump :urlNo="12">
							<el-input v-model="parm.part_code" size="mini" readonly>
								<i  class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThing"></i>
							</el-input>
							</routejump>
						</td>
						<td style="width:60px;min-width:60px"><span>{{$t('getapi[113]')}}</span></td>
						<td style="width:60px;min-width:60px">
							<el-input v-model="parm.part_version" size="mini" :readonly="true" class="readO"></el-input>
						</td>
						<td style="width:60px;min-width:60px"><span>{{$t('getapi[1507]')}}</span></td>
						<td colspan="2" style="width:220px;min-width:220px">
							<routejump :urlNo="12" v-show="parm.AllVender == 0">
							<el-input

									v-model="parm.vender_code"
									size="mini"
									readonly
							>
								<i  class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThings"></i>
							</el-input>
							</routejump>
							<el-input v-show="parm.AllVender == 1" v-model="parm.vender_code" size="mini" :readonly="true" class="readO"></el-input>
						</td>
						<td style="width:140px;min-width:140px">
							<el-checkbox v-model="parm.AllVender" style="margin-left:5px" :true-label="1" :false-label="0" @change="chek" size="mini">{{$t('getapi[6725]')}}</el-checkbox>
						</td>
						<td style="width:60px;min-width:60px"><span>{{$t('getapi[6699]')}}</span></td>
						<td style="width:120px;min-width:120px">
							<routejump :urlNo="15" v-show="Routingflg == false">
							<el-input
									v-model="parm.workproc_name"
									size="mini"
									style="width: 80px;"
									readonly
							>
								<i  class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThingsrout"></i>
							</el-input>
							</routejump>
							<el-input v-show="Routingflg" v-model="parm.workproc_name" size="mini" style="width: 80px;" :readonly="true" class="readO"></el-input>
						</td>
						<td style="width:120px;min-width:120px">
							<el-checkbox v-model="Routingflg" style="margin-left:5px" @change="chekrout" size="mini">{{$t('getapi[6726]')}}</el-checkbox>
						</td>
					</tr>
					<tr>
						<td><span>{{$t('getapi[116]')}}</span></td>
						<td colspan="3"><el-input v-model="parm.part_name" size="mini" :readonly="true" class="readO"></el-input></td>
						<td><span>{{$t('getapi[6339]')}}</span></td>
						<td style="width:140px;min-width:140px">
							<el-date-picker
									v-model="parm.BeginDate"
									type="date"
									value-format="yyyy-MM-dd"
									:placeholder="$t('getapi[548]')"
									style="width: 100%;"
									size="mini"
							></el-date-picker>
						</td>
						<td style="width:80px;min-width:80px"><span>{{$t('getapi[4057]')}}</span></td>
						<td style="width:140px;min-width:140px">
							<el-date-picker
									v-model="parm.EndDate"
									type="date"
									value-format="yyyy-MM-dd"
									:placeholder="$t('getapi[549]')"
									style="width: 100%;"
									size="mini"
							></el-date-picker>
						</td>
						<td><el-button type="primary" size="mini" style="margin-left:5px" @click="qury">{{$t('getapi[1980]')}}</el-button></td>
					</tr>
				</table>
			</div>
			<!--<div class="cont">-->
				<!--<div class="cont1">-->
					<!--<label>{{$t('getapi[112]')}}</label>-->
					<!--<el-input v-model="parm.part_code" size="mini" style="width: 140px;" readonly>-->
						<!--<i  class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThing"></i>-->
					<!--</el-input>-->
					<!--<label>{{$t('getapi[113]')}}</label>-->
					<!--<el-input v-model="parm.part_version" size="mini" style="width: 50px;" :readonly="true" class="readO"></el-input>-->
					<!--<label>{{$t('getapi[1507]')}}</label>-->
					<!--<el-input-->
						<!--v-show="parm.AllVender == 0"-->
						<!--v-model="parm.vender_code"-->
						<!--size="mini"-->
						<!--style="width: 280px;"-->
						<!--readonly-->
					<!--&gt;-->
						<!--<i  class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThings"></i>-->
					<!--</el-input>-->
					<!--<el-input v-show="parm.AllVender == 1" v-model="parm.vender_code" size="mini" style="width: 280px;" :readonly="true" class="readO"></el-input>-->
					<!--<el-checkbox v-model="parm.AllVender" :true-label="1" :false-label="0" @change="chek" size="mini">{{$t('getapi[6725]')}}</el-checkbox>-->
					<!--<label>{{ Currencys }}</label>-->
					<!--<label>{{$t('getapi[6699]')}}</label>-->
					<!--<el-input-->
						<!--v-show="Routingflg == false"-->
						<!--v-model="parm.workproc_name"-->
						<!--size="mini"-->
						<!--style="width: 80px;"-->
						<!--readonly-->
					<!--&gt;-->
						<!--<i  class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThingsrout"></i>-->
					<!--</el-input>-->
					<!--<el-input v-show="Routingflg" v-model="parm.workproc_name" size="mini" style="width: 80px;" :readonly="true" class="readO"></el-input>-->
					<!--<el-checkbox v-model="Routingflg" @change="chekrout" size="mini">{{$t('getapi[6726]')}}</el-checkbox>-->
					<!--<label>{{ Currencys }}</label>-->
				<!--</div>-->
				<!--<div class="cont1">-->
					<!--<label>{{$t('getapi[116]')}}</label>-->
					<!--<el-input v-model="parm.part_name" size="mini" style="width: 230px;" :readonly="true" class="readO"></el-input>-->
					<!--<label>{{$t('getapi[6339]')}}</label>-->
					<!--<el-date-picker-->
						<!--v-model="parm.BeginDate"-->
						<!--type="date"-->
						<!--value-format="yyyy-MM-dd"-->
						<!--:placeholder="$t('getapi[548]')"-->
						<!--style="width: 130px;"-->
						<!--size="mini"-->
					<!--&gt;</el-date-picker>-->

					<!--<label>{{$t('getapi[4057]')}}</label>-->
					<!--<el-date-picker-->
						<!--v-model="parm.EndDate"-->
						<!--type="date"-->
						<!--value-format="yyyy-MM-dd"-->
						<!--:placeholder="$t('getapi[549]')"-->
						<!--style="width: 130px;"-->
						<!--size="mini"-->
					<!--&gt;</el-date-picker>-->
					<!--<el-button type="primary" size="mini" style="margin-left:20px" @click="qury">{{$t('getapi[1980]')}}</el-button>-->
				<!--</div>-->
			<!--</div>-->
		</el-card>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span style="margin-right: 20px;">{{$t('getapi[6727]')}}</span>
				<el-select v-model="chartype" size="mini" @change="selechange">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-checkbox-group v-model="checkList" style="float: right;" @change="checkcha">
					<el-checkbox :label="$t('getapi[6728]')"></el-checkbox>
					<el-checkbox :label="$t('getapi[6729]')"></el-checkbox>
					<el-checkbox :label="$t('getapi[6730]')"></el-checkbox>
				</el-checkbox-group>
			</div>
			<!--为echarts准备一个具备大小的容器dom-->
			<div id="main" :style="{ width: '100%', height: tableHeight + 'px' }"></div>
		</el-card>
		<!-- 物料弹框 -->
		<selector :isVisible="false" :isSplitPage="true" :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getPartInfo" ref="inputPart"></selector>
		<!-- 物料弹框 -->
		<!-- <popudata :isVisible="cgvisible" @getcg="getcg" ref="input"></popudata> -->
		<!-- 供应商弹框 -->
		<supplier :isVisible="gysvisible" @getsupplier="getsupplier" ref="supplierinput"></supplier>
		<!-- 工序 -->
		<selector :isVisible="false" :isSplitPage="true" :postUrl="'/Basic/Popup/GetRoutingDataList'" @callback="getrout" ref="inputrout"></selector>
	</div>
</template>
<script>
import echarts from 'echarts';
import 'echarts-gl';
export default {
	name: 'chartss',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-260
        }
    },
	data() {
		return {
			cgvisible: false, //物料弹框
			gysvisible: false, //供应商弹框
			Routingflg: true, //是否全部外协工序
			parm: {
				AllVender: 1,
				RoutingID: '',
				workproc_name: '',
				vender_code: '',
				part_code: '',
				part_version: '',
				BeginDate: new Date(),
				EndDate: new Date()
			}, //数据
			Currencys: '',
			checkList: [],
			chartype: 0,
			showlabel: false,
			options: [
				{
					value: 0,
					label: this.$t('getapi[8789]')//'折线图'
				},
				{
					value: 1,
					label: this.$t('getapi[8790]')//'梯形图'
				},
				{
					value: 2,
					label: this.$t('getapi[8791]')//'直方图'
				},
				{
					value: 3,
					label: this.$t('getapi[8792]')//'单点图'
				}
			],
			title: '',
			labels: '',
			charts: '',
			y: [],
			x: [],
			x1: [],
			minval: '' //最小值
		};
	},
	beforeRouteEnter(to, form, next) {
		next(vm => {
			if (form.name == 'purorderview' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                const data = {...vm.$store.state.sharedParams};
				vm.parm = {
					AllVender: 0,
					part_name: data.part_name,
					vender_code: data.vender_code,
					part_code: data.part_code,
					part_version: data.part_version,
					BeginDate: data.BeginDate,
					EndDate: data.EndDate
				};
				vm.qury();
                vm.$store.commit('clearSharedParams')
			}
		});
	},
	mounted() {
		/*this.$nextTick(()=>{

        })*/

		let that = this;
		that.authority();
		that.setyes(new Date());
	},
	methods: {
		//获取前一年时间
		setyes(data) {
			let nys = data.setFullYear(data.getFullYear() - 1);
			const sy = new Date(nys);
			this.parm.BeginDate = this.systime(sy);
			this.parm.EndDate = this.systime(new Date());
		},
		systime(time) {
			var pastDate = time,
				pastYear = pastDate.getFullYear(),
				pastMonth = pastDate.getMonth() + 1,
				pastDay = pastDate.getDate();
			return pastYear + '-' + pastMonth + '-' + pastDay;
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[91]"),this.$t("getapi[13]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetButtonEnable('');
		},
		//查询
		qury() {
			this.getdate();
		},
		chek(e) {
			this.parm.AllVender = e;
		},
		chekrout(e) {
			this.Routingflg = e;
		},
		//多选框
		checkcha(e) {
			console.log(e);
			this.drawPie('main');
		},
		//统计图类别
		selechange(e) {
			console.log(e);
			this.chartype = e;
			this.drawPie('main');
		},
		//物料弹框
		doTheThing() {
			console.log('物料弹框开启');
			this.parm.vender_code = '';
			this.cgvisible = true;
			this.$refs.inputPart.clearInputFromFuncd(this.cgvisible, false, { PUBPart_ID: '' }, 10);
			// this.$refs.input.clearInput(this.cgvisible, this.parm.vender_code, 0);
		},
		// 供应商弹框
		doTheThings() {
			if (this.parm.part_code) {
				this.gysvisible = true;
				this.$refs.supplierinput.clearInputs(this.gysvisible, false, 3, this.parm);
			} else {
				this.$message.warning(this.$t('getapi[8793]'));//'请先选择物料'
			}
		},
		//外协工序
		doTheThingsrout() {
			if (this.parm.part_code) {
				this.$refs.inputrout.clearInputFromFuncd(true, false, this.parm, 0);
			} else {
				this.$message.warning(this.$t('getapi[8793]'));//'请先选择物料'
			}
		},
		getrout(val) {
			console.log(val);
			this.parm.RoutingID = val.routing_start_id;
			this.parm.workproc_name = val.workproc_name;
		},
		getsupplier(e) {
			console.log(e);
			this.parm.vender_code = e.vender_code;
		},
		//获取物料信息
		getPartInfo(val) {
			console.log(val);
			this.parm.part_code = val.part_code;
			this.parm.part_name = val.part_name;
			this.parm.part_version = val.part_version;
		},
		// getcg(val) {
		// 	console.log(val);
		// 	this.parm.part_code = val.part_code;
		// 	this.parm.part_name = val.part_name;
		// 	this.parm.part_version = val.part_version;
		// },
		//获取数据
		getdate() {
			let that = this;
			that.showloading = that.openLoading();
			that.y = [];
			that.x = [];
			that.x1 = [];
			that.title = that.parm.part_code + '-' + that.parm.part_version + '(' + that.parm.BeginDate + '-' + that.parm.EndDate + ')';
			if (that.parm.AllVender == 1) {
				that.labels = '全部供应商';
			} else {
				that.labels = '供应商：' + that.parm.vender_code;
			}
			let parm = that.parm;
			if (that.Routingflg) {
				parm.RoutingID = '';
			}
			that.$http.urlpost('/ISS/PQ/GetPurPriceDatas', parm, res => {
				console.log(res);
				if (res.Success == 1) {
					if (res.DataContent.length > 0) {
						let dataj = res.DataContent;
						let valist = new Array();
						dataj.forEach(function(item, index) {
							if (item.cost_std.length > 0 || item.unitprice.length > 0) {
								let ytime = item.pricedate.slice(0, 10);
								if (item.unitprice) {
									valist.push(item.unitprice);
								}
								if (item.cost_std) {
									valist.push(item.cost_std);
								}
								console.log('item.unitprice', item.unitprice);
								that.y.push(ytime);

								that.x.push(item.unitprice);
								that.x1.push(item.cost_std);
							}
						});

						console.log(valist);
						valist.sort(function(a, b) {
							return a - b;
						});
						let iminv = valist[0]; // 5
						that.minval = valist[0] - 3;
						console.log(iminv);
						that.$nextTick(function() {
							that.drawPie('main', iminv - 3);
						});
					} else {
						that.$message.error(that.$t('getapi[8794]'));//暂无数据
					}

					that.showloading.close();
				}else{
					that.showloading.close();
				}
			});
		},
		drawPie(id, minv) {
			let that = this;
			if (that.checkList.indexOf('显示批注信息') >= 0) {
				that.showlabel = true;
			} else {
				that.showlabel = false;
			}
			if (that.checkList.indexOf('单价坐标轴起点为零') >= 0) {
				minv = 0;
			} else {
				minv = that.minval;
			}
			if (that.checkList.indexOf('3D效果') >= 0) {
				this.drawPies(id, minv);
			} else {
				this.showchar(id, minv);
			}
		},
		showchar(id, minv) {
			let that = this;
			let type = 'line';
			let step = '';
			if (that.chartype == 0) {
				type = 'line';
			}
			if (that.chartype == 1) {
				type = 'line';
				step = 'end';
			}
			if (that.chartype == 2) {
				type = 'bar';
			}
			if (that.chartype == 3) {
				type = 'scatter';
			}
			this.charts = echarts.init(document.getElementById(id));
			var option = {
				title: {
					text: that.title,
					subtext: that.labels,
					left: 'center'
				},
				// 循环这样子方便点
				legend: {
					data: ['单价', '标准成本'],
					top: 'bottom'
				},
				color: '#c23531',
				xAxis: {
					type: 'category',
					data: that.y
				},
				yAxis: {
					type: 'value',
					min: minv.toFixed(2)
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				series: [
					{
						name: '单价',
						data: that.x,
						type: type,
						step: step,
						connectNulls: true,
						itemStyle: {
							normal: {
								//这里是重点
								color: '#00ff7f'
							}
						},
						label: {
							normal: {
								show: that.showlabel,
								position: 'top'
							}
						}
					},
					{
						name: '标准成本',
						data: that.x1,
						type: 'line',
						step: '',
						connectNulls: true,
						lineStyle: {
							color: 'red',
							width: 1,
							type: 'dashed'
						},
						itemStyle: {
							borderWidth: 3,
							borderColor: 'red',
							color: 'red'
						},
						label: {
							normal: {
								show: that.showlabel,
								position: 'top'
							}
						}
					}
				]
			};
			this.charts.clear();
			this.charts.setOption(option);
		},
		drawPies(id, minv) {
			let that = this;
			this.charts = echarts.init(document.getElementById(id));
			var xData = that.y;
			var days = [''];
			let ff = [];
			let ff1 = [];
			that.x.forEach(function(item, index) {
				let ls = [0];
				ls.push(index);
				ls.push(item);
				ff.push(ls);
			});
			that.x1.forEach(function(item, index) {
				let ls = [0];
				ls.push(index);
				ls.push(item);
				ff1.push(ls);
			});
			//var data = [[0, 0, 9.8], [0, 1, 9.8], [0, 2, 9.8]];
			var data = ff;
			let type = 'line';
			let step = '';
			if (that.chartype == 0) {
				type = 'line3D';
			}
			if (that.chartype == 1) {
				type = 'line3D';
				step = 'end';
			}
			if (that.chartype == 2) {
				type = 'bar3D';
			}
			if (that.chartype == 3) {
				type = 'scatter3D';
			}
			var option = {
				title: {
					text: that.title,
					subtext: that.labels,
					left: 'center'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				visualMap: {
					show: false,
					max: 15,
					inRange: {
						color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
					}
				},
				xAxis3D: {
					name: 'x',
					nameGap: 1,
					type: 'category',
					data: xData
				},
				yAxis3D: {
					name: '',
					type: 'category',
					mini: minv,
					data: days
				},
				zAxis3D: {
					name: '',
					type: 'value'
				},
				grid3D: {
					boxWidth: 200,
					boxDepth: 20,
					light: {
						main: {
							intensity: 1.2,
							shadow: true
						},
						ambient: {
							intensity: 0.3
						}
					},
					viewControl: {
						alpha: 0,
						beta: 0
					}
				},
				series: [
					{
						type: type,
						step: step,
						connectNulls: true,
						data: data.map(function(item) {
							return {
								value: [item[1], item[0], item[2]]
							};
						}),
						shading: 'lambert',
						label: {
							normal: {
								show: that.showlabel,
								position: 'top'
							},
							textStyle: {
								fontSize: 16,
								borderWidth: 1
							}
						},

						emphasis: {
							label: {
								textStyle: {
									fontSize: 20
								}
							}
						}
					},
					{
						data: ff1.map(function(item) {
							return {
								value: [item[1], item[0], item[2]]
							};
						}),
						type: 'line3D',
						shading: 'lambert',
						connectNulls: true,
						label: {
							normal: {
								show: that.showlabel,
								position: 'top'
							},
							textStyle: {
								fontSize: 16,
								borderWidth: 1
							}
						},

						emphasis: {
							label: {
								textStyle: {
									fontSize: 20
								}
							}
						}
					}
				]
			};
			this.charts.clear();
			this.charts.setOption(option);
		}
	}
};
</script>
<style lang="scss" scoped>
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
.cont {
	width: 100%;
	overflow-x: auto;
	white-space: pre;
	line-height: 40px;
	overflow-y: hidden;
}
.cont1 {
	label {
		margin-right: 20px;
		margin-left: 20px;
	}
	:first-child {
		margin-left: 0;
	}
}
</style>
